import { HttpClient } from "../HttpClient";

export const PostCredit = async (payload) => {
  try {
    const { data } = await HttpClient.post(
      "api/subscriptions/AddCredit",
      payload
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
